import React, { useEffect, useState } from "react";
import API from "../api";
import "./LeaveAttendance.css";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
export default function LeaveAttendance() {
    const navigate = useNavigate();

    const [attendance, setAttendance] = useState([]);
    const [day, setDay] = useState("");
    // const [day, setDay] = useState(() =>
    //     new Date().toISOString().split("T")[0]   // Default: today
    // );
    const [leaves, setLeaves] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const [month, setMonth] = useState("");
    const [username, setUsername] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [leave_status, setLeaveStatus] = useState("");

    const isDaySelected = !!day;
    const isMonthSelected = !!month;
    const isRangeSelected = !!fromDate || !!toDate;


    const limit = 10;
    const totalEntries = leaves.length;
    const totalPages = Math.ceil(totalEntries / limit);
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;

    const currentLeaves = leaves.slice(startIndex, endIndex);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [rejectReason, setRejectReason] = useState("");
    const [viewReason, setViewReason] = useState("");
    const [isViewOnly, setIsViewOnly] = useState(false);
    // -------------------------
    // LOAD DATA
    // -------------------------
    // const loadData = async () => {
    //     let params = { page, limit };

    //     if (day) params.day = day;
    //     if (month) params.month = month;
    //     if (username) params.username = username;
    //     if (fromDate) params.fromDate = fromDate;
    //     if (toDate) params.toDate = toDate;
    //     if (status) params.status = status;


    //     const res = await API.get("/admin/attendance", { params });
    //     setAttendance(res.data);
    // }
    const loadLeaves = async () => {
        try {
            let params = {
                page: 1,
                limit: 10000
            };

            if (day) params.day = day;
            if (month) params.month = month;
            if (fromDate) params.fromDate = fromDate;
            if (toDate) params.toDate = toDate;
            if (username) params.username = username;
            if (leave_status) params.leave_status = leave_status;

            params.role = localStorage.getItem("role");
            params.leadName = localStorage.getItem("username");

            const res = await API.get("/admin/leave", { params });

            console.log("TOTAL LEAVES FROM API:", res.data?.length);

            setLeaves(Array.isArray(res.data) ? res.data : []);
        } catch (error) {
            console.error("Failed to load leaves:", error);
            setLeaves([]);
        }
    };



    useEffect(() => {
        loadLeaves();
    }, [day, month, username, fromDate, toDate, leave_status]);

    // If day selected → reset others
    useEffect(() => {
        if (day) {
            setMonth("");
            setFromDate("");
            setToDate("");
        }
    }, [day]);


    // If month selected → reset day
    useEffect(() => {
        if (month) {
            setDay("");
        }
    }, [month]);


    // If range selected → reset day & month
    useEffect(() => {
        if (fromDate || toDate) {
            setDay("");
            setMonth("");
        }
    }, [fromDate, toDate]);

    useEffect(() => {
        setPage(1);
    }, [day, month, username, fromDate, toDate, leave_status]);
    // const approveLeave = async (id) => {

    //     const confirmApprove = window.confirm(
    //         "Are you sure you want to approve this leave?"
    //     );

    //     if (!confirmApprove) return; // if Cancel clicked, stop here

    //     try {
    //         await API.put(`/admin/leave/approve/${id}`);
    //         loadLeaves();
    //     } catch (err) {
    //         alert("Failed to approve leave");
    //     }
    // };


    // 29-09 changes by aboli


const approveLeave = async (leaveId) => {
 
        console.log("=================================");
        console.log("HR APPROVE CLICKED");
        console.log("Leave ID:", leaveId);
        console.log("=================================");
 
        const confirmApprove = window.confirm(
            "Are you sure you want to approve this leave?"
        );
 
        if (!confirmApprove) return;
 
        try {
 
            const response = await API.put(
                `/admin/hr-approve/${leaveId}`
            );
 
            console.log("HR APPROVE RESPONSE:", response.data);
 
            if (response.data.success) {
                alert("Leave approved successfully");
                loadLeaves();
            }
 
        } catch (err) {
 
            console.error("HR Approve Error:", err);
            console.error("Response:", err.response?.data);
 
            alert(
                err.response?.data?.message ||
                "Failed to approve leave"
            );
        }
    };
    // ----------------------------


    // const rejectLeave = async () => {
    //     await API.put(`/admin/leave/reject/${selectedId}`, {
    //         reject_reason: rejectReason
    //     });
    //     setShowRejectModal(false);
    //     loadLeaves();
    // };

    // 29-09--chnaged by aboli
    const rejectLeave = async () => {
 
        try {
 
            await API.put(`/admin/hr-reject/${selectedId}`, {
                hr_reject_reason: rejectReason
            });
 
            setShowRejectModal(false);
            setRejectReason("");
            setSelectedId(null);
 
            loadLeaves();
 
        } catch (err) {
 
            console.error("HR Reject Error:", err);
 
            alert(
                err.response?.data?.message ||
                "Failed to reject leave"
            );
        }
    };
 

    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
    // CSV DOWNLOAD
    const downloadCSV = async () => {
        try {
            const params = { page: 1, limit: 10000 }; // fetch all

            if (day) params.day = day;
            if (month) params.month = month;
            if (username) params.username = username;
            if (fromDate) params.fromDate = fromDate;
            if (toDate) params.toDate = toDate;
            if (leave_status) params.leave_status = leave_status;

            const res = await API.get("/admin/leave", { params });

            if (!res.data || res.data.length === 0) {
                alert("No data to download");
                return;
            }

            const ws = XLSX.utils.json_to_sheet(res.data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Leave Attendance");

            XLSX.writeFile(wb, "leave_attendance_report.xlsx");
        } catch (err) {
            console.error(err);
            alert("Failed to download Excel");
        }
    };

    return (
        <div className="dashboard-wrapper">
            <div className={`sidebar-container ${sidebarOpen ? "open" : "closed"}`}>
                <Sidebar />
            </div>

            <div className={`page-area ${sidebarOpen ? "" : "full"}`}>
                <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
                <div className="main-content">
                    <div className="container-fluid py-4">
                        {/* <div className="top-navbar">
                                    <div className="nav-left">
                                        <img src="/Dashboard-Red-64.png" className="dash-icon"/>
                                        <span>Attendance Dashboard</span>
                                    </div>
        
                                    <div className="nav-right">
                                        <span className="admin">Admin</span>
                                    </div>
                                </div> */}
                        <div className="dashboard-title">
                            <img
                                src="/Dashboard-Red-64.png"
                                alt="dashboard"
                                className="dashboard-icon"
                            />
                            <span>Dashboard</span>
                        </div>

                        {/* HEADER */}
                        <div className="search-card">
                            <h2>Leave Attendance</h2>
                            <div style={{ position: "relative" }}>
                                <input
                                    type="text"
                                    placeholder="Search Username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                                <span style={{
                                    position: "absolute",
                                    right: 18,
                                    top: "50%",
                                    transform: "translateY(-50%)"
                                }}>🔍</span>
                            </div>
                        </div>
                        {/* FILTERS */}
                        <div className="filter-row">

                            <div className="filter-group">
                                <label className="filter-label">Select Day</label>
                                <input
                                    type="date"
                                    value={day}
                                    disabled={isMonthSelected || isRangeSelected}
                                    onChange={(e) => setDay(e.target.value)}
                                    className="filter-input"
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Select Month</label>
                                <input
                                    type="month"
                                    value={month}
                                    disabled={isDaySelected || isRangeSelected}
                                    onChange={(e) => setMonth(e.target.value)}
                                    className="filter-input"
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">From Date</label>
                                <input
                                    type="date"
                                    value={fromDate}
                                    disabled={isDaySelected}
                                    max={toDate || undefined}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    className="filter-input"
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">To Date</label>
                                <input
                                    type="date"
                                    value={toDate}
                                    disabled={isDaySelected}
                                    min={fromDate || undefined}
                                    onChange={(e) => setToDate(e.target.value)}
                                    className="filter-input"
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Status</label>
                                <select
                                    value={leave_status}
                                    onChange={(e) => setLeaveStatus(e.target.value)}
                                    className="filter-input"
                                >
                                    <option value="">All</option>
                                    {/* <option value="in">In</option>
                                        <option value="out">Out</option>
                                        <option value="half-day">Half Day</option> */}
                                    <option value="leave">Leave</option>
                                </select>
                            </div>

                            <button className="download-btn" onClick={downloadCSV}>
                                ⬇ Download CSV
                            </button>
                        </div>
                        {/* TABLE */}
                        <div className="table-card">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>User</th>
                                        <th>Team_Lead</th>
                                        <th>Date</th>
                                        {/* <th>Time</th> */}
                                        <th>Subject</th>
                                        <th className="reason-column">Reason</th>
                                        <th>Lead_Approval</th>
                                        <th>Hr_Approval</th>

                                        {/* <th>Leave Type</th> */}
                                        <th>Action</th>
                                        <th>Rejected Reason</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {currentLeaves.length === 0 ? (
                                        <tr>
                                            <td colSpan="10" align="center">
                                                No Leave Records
                                            </td>
                                        </tr>
                                    ) : (
                                        currentLeaves.map((row, index) => (
                                            <tr key={row.id}>

                                                {/* Sr. No. */}
                                                <td>
                                                    {(page - 1) * limit + index + 1}
                                                </td>

                                                <td
                                                    style={{
                                                        color: "#0d6efd",
                                                        cursor: "pointer",
                                                        fontWeight: "bold"
                                                    }}
                                                    onClick={() => navigate(`/leave-history/${row.user_id}`)}
                                                >
                                                    {row.user_name}
                                                </td>

                                                <td>{row.Team_Lead}</td>

                                                <td>
                                                    {row.date?.toString().slice(0, 10)}
                                                </td>

                                                <td>{row.subject}</td>

                                                {/* Reason */}
                                                <td className="reason-cell">
                                                    <div className="reason-scroll">
                                                        {row.reason || "-"}
                                                    </div>
                                                </td>

                                                <td>
                                                    <span
                                                        className={
                                                            row.lead_status === "approved"
                                                                ? "approved"
                                                                : row.lead_status === "rejected"
                                                                    ? "rejected"
                                                                    : "pending"
                                                        }
                                                    >
                                                        {row.lead_status}
                                                    </span>
                                                </td>

                                                <td>
                                                    <span
                                                        className={
                                                            row.hr_status === "approved"
                                                                ? "approved"
                                                                : row.hr_status === "rejected"
                                                                    ? "rejected"
                                                                    : "pending"
                                                        }
                                                    >
                                                        {row.hr_status}
                                                    </span>
                                                </td>

                                                <td>
                                                    {/* {row.leave_status === "leave" &&
                                                        row.hr_status === "pending" && ( */}
                                                        {/* 29-09 changed ny aboli */}
                                                        {row.leave_status === "leave" &&
                                                        row.lead_status === "approved" &&
                                                        row.hr_status === "pending" && (
                                                            <>
                                                                <button
                                                                    className="approve-btn"
                                                                    onClick={() => approveLeave(row.id)}
                                                                >
                                                                    Approve
                                                                </button>

                                                                <button
                                                                    className="reject-btn"
                                                                    onClick={() => {
                                                                        setSelectedId(row.id);
                                                                        setIsViewOnly(false);
                                                                        setRejectReason("");
                                                                        setShowRejectModal(true);
                                                                    }}
                                                                >
                                                                    Reject
                                                                </button>
                                                            </>
                                                        )}

                                                    {row.approval_status === "approved" && (
                                                        <span className="approved">
                                                            Approved
                                                        </span>
                                                    )}

                                                    {row.approval_status === "rejected" && (
                                                        <span className="rejected">
                                                            Rejected
                                                        </span>
                                                    )}
                                                </td>

                                                <td>
                                                    {(row.lead_status === "rejected" ||
                                                        row.hr_status === "rejected") && (
                                                            <button
                                                                className="view-btn"
                                                                onClick={() => {
                                                                    const reason =
                                                                        row.lead_status === "rejected"
                                                                            ? row.lead_reject_reason
                                                                            : row.hr_reject_reason;

                                                                    setViewReason(reason);
                                                                    setIsViewOnly(true);
                                                                    setShowRejectModal(true);
                                                                }}
                                                            >
                                                                View
                                                            </button>
                                                        )}
                                                </td>

                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* PAGINATION */}
                        <div className="pagination-section">

                            <span>
                                {totalEntries === 0
                                    ? "Showing 0 entries"
                                    : `Showing ${startIndex + 1} - ${Math.min(
                                        endIndex,
                                        totalEntries
                                    )} of ${totalEntries} entries`
                                }
                            </span>

                            <ul className="pagination">

                                {/* FIRST */}
                                <li className={page === 1 ? "disabled" : ""}>
                                    <button
                                        type="button"
                                        disabled={page === 1}
                                        onClick={() => setPage(1)}
                                    >
                                        «
                                    </button>
                                </li>

                                {/* PREVIOUS */}
                                <li className={page === 1 ? "disabled" : ""}>
                                    <button
                                        type="button"
                                        disabled={page === 1}
                                        onClick={() => {
                                            setPage(prev => prev - 1);
                                        }}
                                    >
                                        ‹
                                    </button>
                                </li>

                                {/* CURRENT PAGE */}
                                <li className="active">
                                    <button type="button">
                                        {page}
                                    </button>
                                </li>

                                {/* NEXT */}
                                <li className={page >= totalPages ? "disabled" : ""}>
                                    <button
                                        type="button"
                                        disabled={page >= totalPages}
                                        onClick={() => {
                                            setPage(prev => prev + 1);
                                        }}
                                    >
                                        ›
                                    </button>
                                </li>

                                {/* LAST */}
                                <li className={page >= totalPages ? "disabled" : ""}>
                                    <button
                                        type="button"
                                        disabled={page >= totalPages}
                                        onClick={() => {
                                            setPage(totalPages);
                                        }}
                                    >
                                        »
                                    </button>
                                </li>

                            </ul>
                        </div>

                        {/* REJECT MODAL */}
                        {/* Reject Modal */}
                        {showRejectModal && (
                            <div className="modal-overlay">
                                <div className="modal-box">
                                    <h4>
                                        {isViewOnly ? "Rejected Reason" : "Reject Leave Reason"}
                                    </h4>

                                    <textarea
                                        value={isViewOnly ? viewReason : rejectReason}
                                        onChange={e => setRejectReason(e.target.value)}
                                        placeholder="Enter reason"
                                        readOnly={isViewOnly}
                                    />

                                    <div className="modal-actions">
                                        {!isViewOnly && (
                                            <button className="approve-btn" onClick={rejectLeave}>
                                                Submit
                                            </button>
                                        )}

                                        <button
                                            className="reject-btn"
                                            onClick={() => {
                                                setShowRejectModal(false);
                                                setRejectReason("");
                                                setViewReason("");
                                                setIsViewOnly(false);
                                            }}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}


                    </div>
                </div>
            </div>
        </div>
    );
}
